'use strict';

var MarketProductGroupClassGroupFilterFactory = function MarketProductGroupClassGroupFilterFactory(DataFilter) {
  function MarketProductGroupClassGroupFilter() {
    DataFilter.call(this, 'market-product-group', 'classGroups');
  }
  MarketProductGroupClassGroupFilter.constructor = MarketProductGroupClassGroupFilter;
  MarketProductGroupClassGroupFilter.prototype = Object.create(DataFilter.prototype);
  MarketProductGroupClassGroupFilter.prototype.groupBy = 'classGroup';
  return MarketProductGroupClassGroupFilter;
};
MarketProductGroupClassGroupFilterFactory.$inject = ['DataFilterFactory'];
module.exports = MarketProductGroupClassGroupFilterFactory;